/* 🤖 this file was generated by svg-to-ts */
export const svgCloseButton: {
    name: "close-button";
    data: string;
} = {
    name: "close-button",
    data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" id="ng__close-button" x="0" y="0" version="1.1" viewBox="0 0 50 50"><g id="ng__close-btn"><circle id="ng__close-button" cx="25" cy="25" r="24" fill="#F6F1EB"/><path fill="#333" d="M34,30c-0.236,0-0.475-0.083-0.664-0.253L25,22.338l-8.335,7.409c-0.414,0.368-1.045,0.331-1.412-0.083 c-0.367-0.412-0.33-1.045,0.083-1.411l9-8c0.379-0.337,0.951-0.337,1.329,0l9,8c0.413,0.366,0.45,0.999,0.083,1.411 C34.55,29.887,34.275,30,34,30z"/></g></svg>`,
};
